import { Navigate } from 'react-router-dom'

/** Legacy route — redirects to unified Listings management (uploads section). */
export default function AdminAccessibilityUploadPage() {
  return <Navigate to="/admin/listings-management#uploads" replace />
}
